var render, staticRenderFns
import script from "./ReportImageSubmissionMixin.vue?vue&type=script&lang=ts"
export * from "./ReportImageSubmissionMixin.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageSubmissionMixin.vue?vue&type=style&index=0&id=23a4d654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4d654",
  null
  
)

export default component.exports